import { render } from "./navbar.vue?vue&type=template&id=4987d12a&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import "./navbar.vue?vue&type=style&index=0&id=4987d12a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4987d12a"]])

export default __exports__